module.exports = __webpack_public_path__ + "img/chips20000.93d0a364.png";